export default __webpack_public_path__ + "static/media/RT_4.6567a9ca.png";